import React, { useState, useEffect } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Select from 'react-select';


const RouteEdit = () => {
    const { id } = useParams();
    const recordId = useParams();
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);
    const [formData, setFormData] = useState({
        name: '',
        code: '',
        routeNo: '',
        pricetype: '',
        Pricetypeid: '',
        UpdatedBy: '',
        isSubmit: false
    });
    /////////////////////////////////////////////////////////
    useEffect(() => {
        fetchData('RouteApi', `/RouteDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Route Details:', error);
            });
    }, [id]);

    const handleChange = (event) => {
        const { name, value, type } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));
    };

    // Route Price Type

    const [rateOptions, setRateOptions] = useState([]);
    const [selectedRateType, setSelectedRateType] = useState("");

    const fetchRateTypes = async () => {
        try {
            const response = await fetchData('PriceTypeApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(price => ({
                    value: price.id,
                    label: price.name
                }));
                setRateOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleRateTypeChange = (selectedOption) => {
        setSelectedRateType(selectedOption);
        setFormData(prevData => ({
            ...prevData,
            pricetype: selectedOption ? selectedOption.label : '',
            Pricetypeid: selectedOption ? selectedOption.value : '',
        }));
    };


    useEffect(() => {
        fetchRateTypes();
    }, []);


    const handleSubmit = (event) => {
        event.preventDefault();

        if (!formData.name) {
            setErrorMessage("Route Name is required!");
            return;
        }

        const resolvedPriceTypeId = selectedRateType ? selectedRateType.value : formData.Pricetypeid;
        if (!resolvedPriceTypeId) {
            setErrorMessage("Price Type is required!");
            return;
        }

        setIsLoading(true);
        setErrorMessage("");

        const updatedFormData = {
            ...formData,
            UpdatedBy: userId,
            Pricetypeid: resolvedPriceTypeId,
        };

        updateData('RouteApi', `${id}`, updatedFormData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/RouteIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <form onSubmit={handleSubmit}>
                <div className="w-full mb-2 flex">
                    <h6 className="uppercase productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}> Route - Edit</h6>

                    <Tooltip title="Exit">
                        <Link to="/RouteIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                            <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                Exit <ExitToAppIcon />
                            </Button>
                        </Link>
                    </Tooltip>


                    <Tooltip title="SAVE">

                        <Button onClick={handleSubmit} style={{ color: 'darkolivegreen', fontWeight: 'bolder', marginLeft: '2px' }} disabled={isLoading}>
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "UPDATE"} <CheckCircleIcon />
                        </Button>

                    </Tooltip>
                </div>

                {/* Display success and error messages if needed */}
                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}


                <div className="w-full mb-4 flex">


                    <div className="w-1/2 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            Name
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter Route Name"
                            maxLength={30}
                        />
                    </div>

                    <div className="w-1/8 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            Code
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name="code"
                            value={formData.code}
                            onChange={handleChange}
                            maxLength={7}
                            type="text"
                            placeholder="Enter Route Code"
                        />
                    </div>


                    <div className="w-1/8 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            RouteNo
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                            name="routeNo"
                            value={formData.routeNo}
                            // onChange={handleChange}
                            onChange={(e) => {
                                const input = e.target.value.replace(/\D/g, ''); // Allow only digits
                                if (input.length <= 25) { // Limit to maxLength
                                    setFormData(prevData => ({
                                        ...prevData,
                                        routeNo: input
                                    }));
                                }
                            }}
                            type="text"
                            placeholder="Enter RouteNo"
                            maxLength={7}
                        />
                    </div>
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            PriceType
                        </label>
                        {/* 
                        <Select
                            //value={selectedRateType}
                            value={selectedRateType || (formData.pricetype ? { value: formData.pricetype, label: formData.pricetype } : '')}
                            onChange={handleRateTypeChange}
                            options={rateOptions}
                            placeholder="PriceOptions"
                            isSearchable
                        /> */}

                        <Select
                            value={selectedRateType || (formData.pricetype ? { value: formData.Pricetypeid, label: formData.pricetype } : null)}
                            onChange={handleRateTypeChange}
                            options={rateOptions}
                            placeholder="PriceOptions"
                            isSearchable
                        />
                    </div>

                </div>
            </form>
        </div>
    );
};

export default RouteEdit;
